import { render } from "./addResource.vue?vue&type=template&id=fb70804c&scoped=true&ts=true"
import script from "./addResource.vue?vue&type=script&lang=ts"
export * from "./addResource.vue?vue&type=script&lang=ts"

import "./addResource.vue?vue&type=style&index=0&id=fb70804c&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb70804c"]])

export default __exports__